import React, { useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/** Faculty/staff Employee ID + registered contact verification. */
export default function BookingStaffVerify({
  slug, primary, onVerified, onNotFound, onBack, mode = 'staff',
}) {
  const [employeeId, setEmployeeId] = useState('');
  const [contact, setContact] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    setError('');
    if (employeeId.trim().length < 3) {
      setError('Enter a valid Employee ID');
      return;
    }
    if (contact.trim().length < 5) {
      setError('Enter registered phone or email');
      return;
    }
    setBusy(true);
    try {
      const path = mode === 'dependent' ? 'dependents' : 'verify-staff';
      const { data } = await axios.post(`${API}/api/tenant/${slug}/book/${path}`, {
        employee_id: employeeId.trim(),
        contact: contact.trim(),
      });
      if (!data?.found) {
        onNotFound(data?.message || 'Record not found', employeeId.trim());
      } else if (mode === 'dependent') {
        onVerified({
          staff: data.staff,
          dependents: data.dependents || [],
          employeeId: employeeId.trim(),
          contact: contact.trim(),
        });
      } else {
        onVerified({
          member: data.member,
          employeeId: employeeId.trim(),
          contact: contact.trim(),
        });
      }
    } catch (e) {
      setError(e?.response?.data?.detail || 'Could not verify. Please try again.');
    }
    setBusy(false);
  };

  return (
    <div className="border-t border-white/10 pt-4 mt-4 space-y-2.5" data-testid="booking-staff-verify">
      <div className="flex items-center justify-between mb-1">
        <p className="text-[11px] uppercase tracking-wider text-zinc-400">
          {mode === 'dependent' ? 'Primary staff verification' : 'Faculty / Staff verification'}
        </p>
        <button type="button" onClick={onBack} className="text-[11px] text-zinc-500 hover:text-zinc-300">Back</button>
      </div>
      <input
        placeholder="Employee ID"
        value={employeeId}
        onChange={(e) => setEmployeeId(e.target.value)}
        className="w-full bg-white/5 border border-white/15 rounded-lg px-3 py-2 text-sm text-white placeholder:text-zinc-500"
        data-testid="booking-employee-id"
      />
      <input
        placeholder="Registered phone or email"
        value={contact}
        onChange={(e) => setContact(e.target.value)}
        className="w-full bg-white/5 border border-white/15 rounded-lg px-3 py-2 text-sm text-white placeholder:text-zinc-500"
        data-testid="booking-staff-contact"
      />
      {error && <p className="text-[11px] text-red-400 bg-red-500/10 border border-red-400/30 rounded p-2">{error}</p>}
      <button
        type="button"
        onClick={submit}
        disabled={busy}
        className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full font-semibold text-white disabled:opacity-60"
        style={{ background: primary }}
        data-testid="booking-verify-staff"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        Verify & continue
      </button>
    </div>
  );
}
